import {Dropdown, IconButton} from 'platform/components';
import {Box} from 'platform/foundation';

import {KeyboardEventHandler, ReactNode} from 'react';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

const SOURCES_MAX_WIDTH = 80;

interface AiComposerSourcesButtonProps extends RequiredTestIdProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  /** Escape inside the list belongs to the composer, not to the dialog around it. */
  onKeyDownCapture: KeyboardEventHandler<HTMLDivElement>;
  children: ReactNode;
}

/** The record facts a draft used, behind one info button: needed to check, not to decide. */
export function AiComposerSourcesButton(props: AiComposerSourcesButtonProps) {
  const label = i18n.t('general.labels.source');

  return (
    <Dropdown
      placement="top-start"
      isOpen={props.isOpen}
      onOpen={() => props.onOpenChange(true)}
      onClose={() => props.onOpenChange(false)}
      dropdownControl={
        <IconButton
          icon="action/info_outline"
          size="small"
          aria-label={label}
          data-testid={props['data-testid']}
        />
      }
      isKeyboardNavigationDisabled
      isFocusManagementDisabled
      isHeightLimited
      data-testid={suffixTestId('dropdown', props)}
    >
      <Box
        padding={3}
        maxWidth={SOURCES_MAX_WIDTH}
        tabIndex={-1}
        onKeyDownCapture={props.onKeyDownCapture}
      >
        {props.children}
      </Box>
    </Dropdown>
  );
}
